import  { useState } from 'react';

export const useInformationForNotification = () => {
  const [showConfirmationToastMessage, setShowConfirmationToastMessage] = useState(false);
  const [routingRuleName, setRoutingRuleName] = useState('');
  const [action, setAction] = useState('');
  return { showConfirmationToastMessage, setShowConfirmationToastMessage, routingRuleName, setRoutingRuleName, action, setAction};
};
